import {isFunction} from 'lodash';
import {useContext, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Button, CopyText, Icon, InformationModal} from 'components';
import {UserContext} from 'context';
import {TRANSLATION_KEYS} from 'locale';
import {ClientConnect} from 'types';
import {settingsUtils} from 'utils';

const T_KEYS = TRANSLATION_KEYS.COMMON.CLIENT_CONNECT;

type Props = {
    open: boolean;
    connect: ClientConnect;
    onSendMessage: () => void;
    onUpdate?: () => void;
    onDelete?: () => void;
    onClose: () => void;
}

export const ClientConnectCreatedModal: React.FC<Props> = ({open, connect, onSendMessage, onUpdate, onDelete, onClose}: Props) => {
    const {t} = useTranslation();
    const {settings} = useContext(UserContext);

    const {smsEnabled, emailEnabled} = useMemo(() => settingsUtils.getClientConnectionMessageAvailability(settings), [settings]);

    const canSendMessage = useMemo(() =>
        smsEnabled && connect?.contacts?.phone || emailEnabled && connect?.contacts?.email,
    [connect, smsEnabled, emailEnabled]);

    return (
        <InformationModal open={open} onClose={onClose}>
            <div>
                <div className='tw-flex tw-justify-center'>
                    <Icon name='check-circle' color='success' size='8xl' thickness='sm' />
                </div>
                <div className='tw-ts-h5-bold tw-text-default-dimmed tw-mt-8 tw-mb-4 tw-flex'>
                    {t(T_KEYS.CREATED_SUCCESSFULLY)}
                    <div className='tw-ml-auto tw-grid tw-grid-cols-2 tw-gap-2'>
                        {isFunction(onUpdate) &&
                            <Icon name='edit' button color='primary' onClick={onUpdate} />}
                        {isFunction(onDelete) &&
                            <Icon name='delete' button color='alert' onClick={onDelete} />}
                    </div>

                </div>
                <div className='tw-mb-1 tw-text-default-dimmed'>{t(T_KEYS.CONNECTION_LINK)}</div>
                <div className='tw-mb-10 tw-leading-base'>
                    {connect?.link}
                    <CopyText
                        text={connect?.link}
                        copiedLabelOnly
                        textInTooltip={false}
                        labelPlacement='left'
                        className='tw-ml-1'
                        iconSize='sm'
                        iconOnly
                    />
                </div>
                {canSendMessage &&
                    <div className='tw-flex tw-justify-center'>
                        <Button color='primary' icon='send' onClick={onSendMessage}>{t(T_KEYS.SEND_BUTTON)}</Button>
                    </div>}
            </div>
        </InformationModal>
    );
};